export const NAVBAR_HEIGHT = 64;
export const NO_BACKGROUND_GRADIENT = 'none';
export const STAGE_BACKGROUND_IMAGE = 'var(--bg-gradient)';
export const BLACK_PAGE_BACKGROUND_COLOR = '#000000';
export const TRANSPARENT_PAGE_BACKGROUND_COLOR = 'transparent';
export const STAGE_MOBILE_CLASS_NAME = 'stage stage--mobile';
export const STAGE_NON_MOBILE_CLASS_NAME = 'stage stage--non-mobile';
export const STAGE_ROOT_PAGE_CLASS_NAME = 'stage--root-page';
export const STAGE_NON_ROOT_PAGE_CLASS_NAME = 'stage--non-root-page';
export const SESSIONS_MODAL_TITLE = 'Sessions';
export const ARCHIVED_SESSIONS_MODAL_TITLE = 'Archived Sessions';
export const CSS_POINTER_EVENTS_NONE = 'none';
export const CSS_POINTER_EVENTS_AUTO = 'auto';
export const CSS_POSITION_ABSOLUTE = 'absolute';
export const CSS_POSITION_RELATIVE = 'relative';
export const NAVBAR_TRANSLATE_Y_HIDDEN = 'translateY(-8px)';
export const NAVBAR_TRANSLATE_Y_VISIBLE = 'translateY(0)';
export const NAVBAR_CENTER_TRANSFORM_HIDDEN = 'translateX(-50%) translateY(-8px)';
export const NAVBAR_CENTER_TRANSFORM_VISIBLE = 'translateX(-50%) translateY(0)';
export const NAVBAR_LOADING_KEY = 'navbar-loading';
export const NAVBAR_NON_LOGGED_LANDING_KEY = 'navbar-nonlogged-landing';
export const NAVBAR_NON_LOGGED_KEY = 'navbar-nonlogged';
export const NAVBAR_LOGGED_LANDING_KEY = 'navbar-logged-landing';
export const NAVBAR_LOGGED_KEY = 'navbar-logged';
